module.exports = __webpack_public_path__ + "static/media/sweetalert_success.4a803773.png";